<template>
    <div class="page-wrapper">
        <CustomHeader v-if="!isTabView" :text="$t('profile.fundHistory')" :is-popup-close-back-icon="true"
            @close-popup="navToBack" bg-color="#101423" />
        <div class="container" :style="{ paddingTop: isTabView ? '' : '70px' }">
            <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
                <van-tab v-for="(item, index) in dataSet.tabList" :key="index" :title="$t(item.name)" :name="item.id">
                    <div class="content">
                        <div id="subTabContainer">
                            <van-tabs v-model:active="subActive" sticky :ellipsis="false" @click-tab="onClickSubTab">
                                <van-tab v-for="(item, index) in dataSet.subTabList" :key="index" :title="$t(item.name)"
                                    :name="item.id">
                                </van-tab>
                            </van-tabs>
                        </div>
                        <div v-if="dataSet?.dataLog?.length > 0">
                            <!-- Recharge -->
                            <div v-if="item.id == 2" class="rechargeDataSet">
                                <div v-for="(item, index) in dataSet?.dataLog" :key="index">
                                    <CustomDataRow :card-data="item" :status="setRechargeStatus(item.status)"
                                        :class="index % 2 === 0 ? 'row-dark' : 'row-light'" />
                                </div>
                            </div>
                            <!-- Withdraw -->
                            <div v-if="item.id == 3" class="rechargeDataSet">
                                <div v-for="(item, index) in dataSet?.dataLog" :key="index">
                                    <CustomDataRow :card-data="item" :status="setWithdrawStatus(item.status)"
                                        :class="index % 2 === 0 ? 'row-dark' : 'row-light'" />
                                </div>
                            </div>
                            <!-- Flow log -->
                            <div v-if="item.id == 1" class="flowLogDataSet">
                                <div v-for="(item, index) in dataSet?.dataLog" :key="index">
                                    <FlowLogCard :card-data="item"
                                        :class="index % 2 === 0 ? 'row-dark' : 'row-light'" />
                                </div>
                            </div>
                            <van-row v-if="dataSet.total > dataSet.pageSize * dataSet.pageNum">
                                <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png"
                                        alt="" @click="getNextPageList"></van-col>
                            </van-row>
                            <div v-else class="no_more">{{ $t('common.NoMoreData') }}</div>
                        </div>
                        <div v-else>
                            <NoData />
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import { FundHistoryData, setRechargeStatus, setWithdrawStatus } from '@/view/fundHistory/supportScript';
import CustomDataRow from './components/customDataRow.vue';
import NoData from '../components/common/noDataCustom.vue';
import FlowLogCard from './components/flowLogCard.vue';
import { useRoute, useRouter } from 'vue-router';
const props = defineProps<{
    dataSet: FundHistoryData
    isTabView?: boolean
}>()
const router = useRouter()
const active = ref(props.dataSet.active);
const subActive = ref(props.dataSet.subActive);
const route = useRoute()
const emits = defineEmits(['onClickTab', 'getNextPageList', 'onClickSubTab'])

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const onClickSubTab = (active: any) => {
    emits('onClickSubTab', active)
}
const getNextPageList = () => {
    emits('getNextPageList')
}
const navToBack = () => {
    if (Number(route.query.tabIndex) == 0) {
        router.replace({ path: '/sd-topup', query: { tabIndex: 0 } })
    } else if (Number(route.query.tabIndex) == 1) {
        router.replace({ path: '/sd-withdraw', query: { tabIndex: 1 } })
    } else {
        router.go(-1)
    }
}
onMounted(() => {
    if (route.query.tabIndex) {
        active.value = Number(route.query.tabIndex) === 0 ? 2 : 3
    }
})
</script>

<style scoped>
.page-wrapper {
    background-color: #090f1f !important;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.unique-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    padding: 0 16px;
    background-color: #101423;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    position: sticky;
    top: 0;
    z-index: 100;
}

.header-left {
    flex: 1;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.close-icon {
    font-size: 20px;
    color: #ffffff;
    transition: opacity 0.2s;
}

.close-icon:active {
    opacity: 0.6;
}

.header-title {
    flex: 3;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.header-right {
    flex: 1;
}

.container {
    width: 100%;
    position: center;
    padding: 10px 0;

}

.container>>>.van-tabs__wrap {
    height: auto;
    padding: 10px 0;
}

.container>>>.van-tabs__line {
    background-color: #38a8fa;
    height: 3px;
    border-radius: 2px;
    bottom: 0px;
}

.container>>>.van-tabs__nav--line {
    padding-bottom: 0;
}

.container :deep(.van-tab) {
    padding: 0 10px;
}

.container>>>.van-tabs__nav {
    background: transparent;
    margin: 0;
    padding: 0;

}

/* .container :deep(.van-tabs) {
    --van-tab-active-text-color: #38a8fa;
} */

.container>>>.van-tab--active .van-tab__text {
    color: #38a8fa;
}

.container>>>.van-tab {
    background: transparent;
    color: 9;
    font-size: 16px;
    margin: 0px;
    height: 40px;
    font-weight: 500;
    padding: 0 20px;
    border: none;
    transition: 0.3s;
    width: fit-content;
}

.container>>>.van-tab--active,
.container>>>.van-tab {
    border-radius: 0;
}

.container :deep(.van-tabs__wrap) {
    background-color: rgb(9, 15, 31) !important;
    position: relative;
    z-index: 99;
}

.content {
    color: #fff;
    margin: 0 15px;
    min-height: 75vh;
}

.top_card {
    background: #312734;
    border-radius: 10px;
    padding: 15px;
}

.card_text {
    color: #c19aba;
    font-size: 11.75px;
    padding: 2.5px 0;
}

.card_text span {
    font-size: 13px;
    color: #ffffffa6;
}

.sub_text {
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    padding: 15px 70px;
    font-size: 14px;
}

.no_more {
    color: #8ca1cd;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 16px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}

#subTabContainer :deep(.van-tab.van-tab--active) {
    background: #38a8fa !important;
    border-radius: 10px;
}

#subTabContainer :deep(.van-tab--active .van-tab__text) {
    color: #fff !important;
}
</style>